export default "__VITE_ASSET__87pIQa5J__"